import React from 'react';
import { retryLazyImport } from '../../Store/SessionManager';

import {
    FormControl,
    FormHelperText,
} from '@mui/material';


// import { styled } from '@mui/material/styles';
import styled from 'styled-components';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';
import CustomExclamationHover from './CustomExclamationHover';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { CustomCheckboxInterface } from '../../Models/Common/FormFieldComponentInterfaces';

type ColorTypes = { [K in ButtonType]: {
    type: K,
    background: string,
    textColor: string,
} };

const CheckBoxColors: ColorTypes = {
    [ButtonType.PRIMARY]: {
        type: ButtonType.PRIMARY,
        background: "var(--textInfoColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.PRIMARY_LIGHT]: {
        type: ButtonType.PRIMARY_LIGHT,
        background: "var(--fieldSwitchedCheckedBGSecondaryColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.SUCCESS]: {
        type: ButtonType.SUCCESS,
        background: "var(--fieldSwitchedCheckedBGSuccessColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.SUCCESS_LIGHT]: {
        type: ButtonType.SUCCESS_LIGHT,
        background: "var(--fieldSwitchedCheckedBGSuccessLightColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.SECONDARY]: {
        type: ButtonType.SECONDARY,
        background: "var(--fieldSwitchedCheckedBGCancelColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.DELETE]: {
        type: ButtonType.DELETE,
        background: "var(--fieldSwitchedCheckedBGDangerColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.WARNING]: {
        type: ButtonType.WARNING,
        background: "var(--textWarningColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.PREV_NEXT]: {
        type: ButtonType.PREV_NEXT,
        background: "var(--transparent) !important",
        textColor: "gray !important",
    },
    [ButtonType.WHITE]: {
        type: ButtonType.WHITE,
        background: "var(--transparent) !important",
        textColor: "gray !important",
    },
    [ButtonType.DELETE_LIGHT]: {
        type: ButtonType.DELETE_LIGHT,
        background: "var(--fieldSwitchedCheckedBGDangerColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.CANCEL]: {
        type: ButtonType.CANCEL,
        background: "var(--buttonIconCancelColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.CANCEL_LIGHT]: {
        type: ButtonType.CANCEL_LIGHT,
        background: "var(--buttonIconCancelColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
    [ButtonType.PRIMARY_NO_BG]: {
        type: ButtonType.PRIMARY_NO_BG,
        background: "var(--textInfoColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
    },
}

const Label = styled.label<{}>`
    display: block;
    width: fit-content;
    cursor: pointer;
`;

const CheckboxContainer = styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;

    .textFieldLabel {
        color: ${(props) => props.theme.primaryText};
        font-size: 13px;
        font-weight: 600;
        margin: 0px;
        align-self: center;
    }

`;

const LabelText = styled.span <{ $checkboxtype: ButtonType; }>`
    // color: ${(props) => props.theme.primaryText};
    color: ${(props) => CheckBoxColors[props.$checkboxtype].background};
    font-size: 0.775rem;
    font-weight: 400;
    margin: 3px 0px 0px 5px;
    align-self: center;
`;

const StyledCheckbox = styled.input.attrs({ type: "checkbox" }) <{ $checkboxtype: ButtonType; }>`
    min-width: 15px;
    min-height: 15px;
    border-radius: 3px !important;
    box-sizing: content-box;
    cursor: pointer;
    -webkit-appearance: none;
    border-radius: 2px;
    background-color: var(--transparent);
    // border: 1px solid ${(props) => (props.theme.border)};
    border: 1px solid;
    border-color: ${(props) => CheckBoxColors[props.$checkboxtype].background};

    &:checked {
        background-color: ${(props) => CheckBoxColors[props.$checkboxtype].background};
        border-color: 'gray !important';   
    }

    &:disabled {
        background-color: ${(props) => (props.theme.disabled)};
        border-color: ${(props) => (props.theme.border)};
        cursor: not-allowed;
    }

    &:checked:disabled:before {
        border-color: 'gray !important';    
    }

    &:before {
        content: '';
        display: block;
        transition: transform 200ms;
    }

    &:checked:before {
        // width: 4px;
        // height: 9px;
        // margin: 3px 7px;
        width: 3px;
        height: 8px;
        margin: 1px 5px;
        border-bottom: 2px solid ${(props) => CheckBoxColors[props.$checkboxtype].textColor};
        border-right: 2px solid ${(props) => CheckBoxColors[props.$checkboxtype].textColor};
        transform: rotate(45deg);
    }
`;

const RequiredIndicator = styled.div<{}>`
    color: var(--textDangerColor);
    font-size: 13px;
    font-weight: 600;
    margin: 0px 0px 0px 5px;
`;

const CustomCheckbox = (fieldProps: CustomCheckboxInterface) => {
    let isdarkmode = (LocalStorageHelper.isDarkMode() ? LocalStorageHelper.isDarkMode() : false);
    const checkboxProps: any = {
        $checkboxtype: fieldProps.checkboxType,
        checked: fieldProps.fieldValue,
        onChange: (e: any) => {
            fieldProps.handleOnChange(e.target.checked);
        },
    }

    const errorMsg = (fieldProps.errorMessages ? fieldProps.errorMessages[fieldProps.name] : null) ?? null;

    return <Label className="checkBoxContainer">
        <FormControl error={errorMsg != null} variant="standard" className="formControlContainer">
            <CheckboxContainer className="formCheckboxContainer">
                {/* ---------CHECKBOX---------- */}
                <StyledCheckbox {...checkboxProps}
                    disabled={fieldProps.disabled || false} />

                {/* ---------TITLE---------- */}
                <LabelText $checkboxtype={fieldProps.checkboxType} className="checkboxSideLabel">{fieldProps.title}</LabelText>

                {fieldProps.exclamationHoverItemDisplayText && <CustomExclamationHover hoverText={fieldProps.exclamationHoverItemDisplayText} />}

                {/* ---------IS REQUIRED INDICATOR---------- */}
                <RequiredIndicator>{!fieldProps.hideLabel && fieldProps.required ? "*" : ""}</RequiredIndicator>
            </CheckboxContainer>

            {/* ---------ERROR---------- */}
            <FormHelperText>{errorMsg}</FormHelperText>
        </FormControl>
    </Label>
}

export default CustomCheckbox;